import React from 'react'

/** @deprecated */
export function ScrollableContainer(props: React.PropsWithChildren<any>) {
  return <div {...props} style={{ overflow: 'auto', ...props.style }} />
}
